import React from "react";

const SpeltipsIcon = props => {
  const color = props.color;
  return (
    <svg width={23} height={20} {...props}>
      <title>products</title>
      <g fill="none" fillRule="evenodd">
        <path fill={color} d="M7.619 3.81h14.603v15.873H7.619z" />
        <path fill={color} d="M3.81 1.905h14.603v15.873H3.81z" />
        <path fill={color} d="M0 0h14.603v15.873H0z" />
        <path fill="#4A4A4A" d="M7.619 3.175h10.794v1H7.619z" />
        <path
          fill="#4A4A4A"
          d="M7.62 3.174v14.603h-1V3.174zM3.81 1.27h10.794v1H3.81zM3.81 1.27v14.603h-1V1.27z"
        />
      </g>
    </svg>
  );
};
export default SpeltipsIcon;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuIcons/SpeltipsIcon.js